import { render, staticRenderFns } from "./productFirst.vue?vue&type=template&id=1968e94e&scoped=true"
import script from "./productFirst.vue?vue&type=script&lang=js"
export * from "./productFirst.vue?vue&type=script&lang=js"
import style0 from "./productFirst.vue?vue&type=style&index=0&id=1968e94e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1968e94e",
  null
  
)

export default component.exports